import { get, isEmpty } from 'lodash';
import { push } from 'connected-react-router';
import { logout } from '../actions';
import { appNamedRoutes } from '../routes';

export default store => next => action => {
  if (get(action, 'payload.name') === 'ApiError') {
    switch (action.payload.status) {
      case 401: {
        const errors = get(action.payload, 'response.errors', {});
        store.dispatch(logout({ errors: isEmpty(errors) ? { 'api': get(action.payload, 'response.error', action.payload.message) } : errors }));
        break;
      }
      case 404: {
        store.dispatch(push(appNamedRoutes.notFound));
        break;
      }
      default:
        return next(action);
    }
  } else {
    return next(action);
  }
}
